import { clsx } from 'clsx';
import type { OnboardingStep } from '../types/onboarding';
import type { PermissionKind } from './steps/permissions-step';
import { EditorCard } from './constellation/editor-card';
import { CanvasCard } from './constellation/canvas-card';
import { AssistantCard } from './constellation/assistant-card';
import { CalendarCard } from './constellation/calendar-card';
import { PermissionGlyphs } from './constellation/permission-glyphs';
import styles from './onboarding-constellation.module.css';

interface OnboardingConstellationProps {
  step: OnboardingStep;
  /** Map of permission grant results to light the glyphs. */
  granted: Record<PermissionKind, boolean>;
}

/**
 * The right-panel visual stage: gradient background + four floating product
 * cards + permission glyphs on step 3. Step-keyed focus is driven by CSS
 * via data-step on the root element.
 */
export function OnboardingConstellation({ step, granted }: OnboardingConstellationProps) {
  return (
    <div className={styles.root} data-step={step} aria-hidden data-tauri-drag-region>
      <div className={styles.stage}>
        <div className={styles.constellation}>
          {/* Four floating product cards — always present, opacity keyed by data-step CSS */}
          <div className={clsx(styles.atom, styles.atomEditor)}>
            <EditorCard />
          </div>
          <div className={clsx(styles.atom, styles.atomCanvas)}>
            <CanvasCard />
          </div>
          <div className={clsx(styles.atom, styles.atomAssistant)}>
            <AssistantCard />
          </div>
          <div className={clsx(styles.atom, styles.atomCalendar)}>
            <CalendarCard />
          </div>

          {/* Permission glyphs — centred, visible only on step 3 */}
          <PermissionGlyphs
            granted={granted}
            visible={step === 'permissions'}
          />
        </div>
      </div>
    </div>
  );
}
